import React from 'react';
import { Modal, Spinner, ModalWindow } from 'bv-components';
import withLazyLoad from 'bv-lazy-load';

const modalRoutesLazyLoad = withLazyLoad(<ModalWindow><Spinner /></ModalWindow>);

export const Settings = modalRoutesLazyLoad('settings');
export const UserInbox = modalRoutesLazyLoad('userInbox');
export const AccountOverview = modalRoutesLazyLoad('accountOverview');
export const ReferAFriend = modalRoutesLazyLoad('referAFriend');
export const CashierActions = modalRoutesLazyLoad('cashierActions');
export const ContactUs = modalRoutesLazyLoad('contactUs');
export const RequestCallback = modalRoutesLazyLoad('requestCallback');
export const TimeOut = modalRoutesLazyLoad('timeOut');
export const AccountHistory = modalRoutesLazyLoad('accountHistory');
export const PasswordChange = modalRoutesLazyLoad('passwordChange');
export const PasswordReset = modalRoutesLazyLoad('passwordReset');
export const Registration = modalRoutesLazyLoad('registration');
export const VerificationZone = modalRoutesLazyLoad('verificationZone');
export const PersonalDetails = modalRoutesLazyLoad('personalDetails');
export const SaferGamblingQuestionnaire = modalRoutesLazyLoad('saferGamblingQuestionnaire');
export const SaferGamblingPortal = modalRoutesLazyLoad('saferGamblingPortal');
export const TwoFACode = modalRoutesLazyLoad('twoFACode');
export const TwoFADeviceManager = modalRoutesLazyLoad('twoFADeviceManager');
export const TwoFAEnable = modalRoutesLazyLoad('twoFAEnable');
export const TwoFARegisterPhone = modalRoutesLazyLoad('twoFARegisterPhone');
export const TwoFATotpScan = modalRoutesLazyLoad('twoFATotpScan');
export const TwoFATotp = modalRoutesLazyLoad('twoFATotp');
export const TwoFAVerifyPassword = modalRoutesLazyLoad('twoFAVerifyPassword');
export const Login = modalRoutesLazyLoad('login');
export const AsiaCashier = modalRoutesLazyLoad('asiaCashier');
export const EmailVerification = withLazyLoad(
  <Modal info><Spinner big={false} /></Modal>,
)('emailVerification');
export const QuickDeposit = modalRoutesLazyLoad('quickDeposit');
export const Feedback = modalRoutesLazyLoad('feedback');
export const GreyHoundsTimeTable = modalRoutesLazyLoad('greyHoundsTimeTable');
export const SaferGamblingLanding = modalRoutesLazyLoad('saferGamblingLanding');
export const MyTransactions = modalRoutesLazyLoad('myTransactions');
